import { createStore as createVuexStore } from "vuex";

export const createStore = (app) => {
  return createVuexStore({
    state: {
      currentState: "",
      // axios: getCurrentInstance()?.appContext?.config?.globalProperties?.$axios,
    },
    mutations: {
      SET_STATE(state, lastState) {
        state.currentState = lastState[0];
      },
      RESET_STATE(state) {
        state.currentState = "";
      },
    },
    actions: {
      async getProjectId({ commit }, projectId) {
        // console.log("Llega a ejecutar getProjectId: ", projectId);
        try {
          if (projectId != null) {
            const response = await app.config.globalProperties.axios.get(
              `/project/${projectId}`
            );
            if (response.data && response.data.Stages.length > 0) {
              const lastState = response.data.Stages.map((st) => st.state);
              commit("SET_STATE", lastState.slice(-1));
            }
          }
        } catch (error) {
          throw new Error(error);
        }
      },
    },
    getters: {},
  });
};
